import template from './info-widget.html';
import controller from './info-widget.controller';
import './info-widget.styl';

let infoWidgetComponent = {
  restrict: 'E',
  bindings: {
      topic: '@',
      label: '@',
      link: '@'
  },
  template,
  controller
};

export default infoWidgetComponent;



// WEBPACK FOOTER //
// ./client/app/common/info-widget/info-widget.component.js